import { render } from "./PosPromotionsPanel.vue?vue&type=template&id=566a356e&scoped=true"
import script from "./PosPromotionsPanel.vue?vue&type=script&lang=js"
export * from "./PosPromotionsPanel.vue?vue&type=script&lang=js"

import "./PosPromotionsPanel.vue?vue&type=style&index=0&id=566a356e&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-566a356e"]])

export default __exports__